import { z } from 'zod'

/** Lists across the app (M2.5): facts per container and bulk actions. Paths below /api/v1. */

const id = z.uuid()
const isoDateTime = z.iso.datetime({ offset: true })

// GET /facts?containerId= → Fact[] (newest first) · DELETE /facts/:id
export const Fact = z.object({
  id,
  containerId: id.nullable(),
  subject: z.string(),
  predicate: z.string(),
  object: z.string(),
  confidence: z.number().nullable(),
  /** where it was learned, e.g. a meeting */
  source: z.object({ type: z.literal('meeting'), id, title: z.string() }).nullable(),
  createdAt: isoDateTime,
})
export type Fact = z.infer<typeof Fact>
export const ListFactsQuery = z.object({ containerId: id })

/**
 * POST /bulk → BulkResult. Several notes/meetings/tasks at once (checkbox selection in lists).
 * trash = soft delete (notes and meetings go to the trash, tasks are soft-deleted; never a hard delete) ·
 * move = into containerId (null = inbox). A meeting note moves together with its meeting.
 * Each item runs on its own: one failing item does not stop the others.
 */
export const BulkAction = z.object({
  action: z.enum(['trash', 'move']),
  items: z
    .array(z.object({ type: z.enum(['note', 'meeting', 'task']), id }))
    .min(1)
    .max(500),
  containerId: id.nullable().optional(),
})
export type BulkAction = z.infer<typeof BulkAction>
export const BulkResult = z.object({
  done: z.number().int(),
  failed: z.array(z.object({ id, message: z.string() })),
})
export type BulkResult = z.infer<typeof BulkResult>
